import { useConfig } from '../defaultConfig';
import { useAccountNumber } from '../fetchHooks/useAccount';
import useEFakturaAccountNumber from '../fetchHooks/useEFakturaAccount';
import type { Account } from '../generated-types';

const useEFakturaAccount = (): Account | undefined | null => {
    const {
        featureToggles: { enableEFakturaAccount },
    } = useConfig();
    const { data: eFakturaAccountNumber } = useEFakturaAccountNumber({ enabled: enableEFakturaAccount });
    const { data: eFakturaAccount } = useAccountNumber(eFakturaAccountNumber);

    return eFakturaAccount;
};

export default useEFakturaAccount;
